import React, { useState } from 'react'
import { Button } from '@blueprintjs/core'
import { useDispatch } from 'react-redux'
import { GenericElement } from '../../templates/FormElement'
import * as con from '../../GlobalConstants'
import { formatDate, getToday, parseDate, minDate, maxDate } from '../../utils/dateFunctions'
import { makeMarketDataReport } from '../../utils/reportFunctions'

function MarketDataReport() {

    const dispatch = useDispatch()
    const [startDate, setStartDate] = useState(formatDate(getToday()))
    const [endDate, setEndDate] = useState(formatDate(getToday()))

    return (
        <div className="columnParameterBoxTop">

            <h3>Descargar Datos de Mercado</h3>

            <div className="smallParameterBox">
                <GenericElement
                    type={con.DATE}
                    name="Fecha Inicio"
                    value={startDate}
                    setValue={(val) =>
                        setStartDate(formatDate(minDate(parseDate(val), parseDate(endDate))))
                    }
                />

                <GenericElement
                    type={con.DATE}
                    name="Fecha Fin"
                    value={endDate}
                    setValue={(val) =>
                        setEndDate(formatDate(maxDate(parseDate(val), parseDate(startDate))))
                    }
                />
            </div>

            <Button
                icon="download"
                text="Descargar Excel"
                onClick={() => dispatch(makeMarketDataReport({ startDate, endDate }))}
            />
        </div>
    )
}

export default MarketDataReport